import { app, context, putContext, v } from "modular-openscriptjs";
import { getStoreSync } from "./helpers";
import { dom } from "./fotastart";
import { $e } from "./ojs.events";

/**
 * Get Context
 */
putContext(["global", "user", "page"], "UrgentContext");
putContext("data", "DataContext");
putContext("payment");
putContext(["admin", "purchase"]);

/**
 * The global context.
 */
export const gc = context("global");

/**
 * The user context.
 */
export const uc = context("user");

/**
 * The data context.
 */
export const dc = context("data");

/**
 * The page data context.
 */
export const pc = context("page");

gc.states({
    auth: false,
    user: {},
    appLoaded: false,
    appConfigReloaded: false,
    appLoadedAt: null,
    appInForeground: true,
});

gc.qrScanner = null;

uc.states({
    permissions: new Set(),
    roles: new Set(),
    capa: { balance: 0 },
    settings: {},
    awards: [],
});

pc.states({
    headerItems: [],
    sideItems: [],
    bottomItems: [],
    offCanvasItems: [],
    pageTitle: "",
    activePage: "",
    sideNavCollapsed: JSON.parse(getStoreSync("sideNavCollapse")) ?? false,
});

pc.sideNavCollapsed.listener(() => {
    let sideNav = dom.get("[ojs-hook='side-nav-container']");
    let mainContent = dom.get("[ojs-hook='main-content-container']");

    if (pc.sideNavCollapsed.value) {
        sideNav?.classList.remove("col-lg-3");
        sideNav?.classList.add("col-lg-1");
        mainContent?.classList.remove("col-lg-8");
        mainContent?.classList.add("col-lg-10");
    } else {
        sideNav?.classList.remove("col-lg-1");
        sideNav?.classList.add("col-lg-3");
        mainContent?.classList.remove("col-lg-10");
        mainContent?.classList.add("col-lg-8");
    }
});

dc.states({
    orderFilters: {
        statuses: { confirmed: true },
        multipleStatuses: false,
        toDate: null,
        fromDate: null,
        orderBy: "desc",
        orderColumn: "urgency",
        deliverers: [window.currentUser?.id],
    },

    orderPage: 1,
    notificationsCount: { total: 0, unread: 0 },
    selectedOrders: {},
    selectedItems: {},
    orderItemsMapping: {},
    orderCodes: {},
    purchasePrices: {},
    buyFromSomewhereElse: {},
    buyAnotherItem: {},
    deliveryCompanies: [],
    currentDeliveryCompany: {},
});

dc.selectedItems.listener((state) => {
    app('broker').send($e.app.has.selectedOrderItems);
})

dc.permWaitInterval = 4 * 60 * 60 * 1000;
dc.longitude = null;
dc.latitude = null;
dc.capaSymbol = "Ç";
dc.userCurrency = "KES";
dc.GA_PID = import.meta.env.VITE_GA_PID;

export const ac = context("admin");
export const purCxt = context("purchase");

ac.states({
    orders: [],
    actions: null,
    activeOrder: null,
});

purCxt.states({
    additionalAmount: 0,
});

purCxt.paymentInfo = {
    method: "mpesa",
    mpesaType: "till",
    mpesaInfo: {
        till: { number: "", account: "" },
        paybill: { number: "", account: "" },
        phone: { number: "", account: "" },
        transaction: { number: "", account: "" },
    },
};

app().value("dc", dc);
app().value("uc", uc);
app().value("pc", pc);
app().value("gc", gc);
app().value("ac", ac);
app().value("purCxt", purCxt);
